import React, { useState } from 'react';
import { ArrowLeftIcon } from 'lucide-react';
import SignupForm from '../components/auth/SignupForm';
import SportSelection from '../components/auth/SportSelection';
import ProfileTypeSelection from '../components/auth/ProfileTypeSelection';
import ProfileDetailsForm from '../components/auth/ProfileDetailsForm';
import SignupSuccess from '../components/auth/SignupSuccess';
export interface SignupData {
  email: string;
  password: string;
  fullName: string;
  username: string;
  sport: string;
  profileType: string;
  profileDetails?: {
    // Player
    position?: string;
    height?: string;
    weight?: string;
    dominantSide?: string;
    experience?: string;
    currentTeam?: string;
    // Coach
    coachingSpecialty?: string;
    coachingLevel?: string;
    teamsCoached?: string[];
    // Manager
    managementSpecialty?: string;
    teamsManaged?: string[];
    // Agent
    agencyName?: string;
    specialization?: string[];
    clientCount?: number;
    // Scout
    scoutingSpecialty?: string;
    organizations?: string[];
    // Referee
    refereeLevel?: string;
    leagues?: string[];
    // Journalist
    publication?: string;
    coverageAreas?: string[];
    // Fan
    favoriteTeams?: string[];
    fanClubs?: string[];
  };
}
const SignupPage = () => {
  const [step, setStep] = useState(1);
  const [signupData, setSignupData] = useState<SignupData>({
    email: '',
    password: '',
    fullName: '',
    username: '',
    sport: '',
    profileType: '',
    profileDetails: {}
  });
  const updateSignupData = (data: Partial<SignupData>) => {
    setSignupData(prev => ({
      ...prev,
      ...data
    }));
  };
  const handleNext = () => {
    setStep(step + 1);
  };
  const handleBack = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };
  const handleSubmit = () => {
    // In a real app, you would send the data to your backend here
    console.log('Signup data:', signupData);
    // Move to success step
    setStep(5);
  };
  const renderStep = () => {
    switch (step) {
      case 1:
        return <SignupForm onNext={handleNext} updateData={updateSignupData} data={signupData} data-id="element-843" />;
      case 2:
        return <SportSelection onNext={handleNext} onBack={handleBack} updateData={updateSignupData} selectedSport={signupData.sport} data-id="element-844" />;
      case 3:
        return <ProfileTypeSelection onNext={handleNext} onBack={handleBack} updateData={updateSignupData} selectedType={signupData.profileType} data-id="element-845" />;
      case 4:
        return <ProfileDetailsForm onSubmit={handleSubmit} onBack={handleBack} updateData={updateSignupData} data={signupData} data-id="element-846" />;
      case 5:
        return <SignupSuccess data={signupData} data-id="element-847" />;
      default:
        return <SignupForm onNext={handleNext} updateData={updateSignupData} data={signupData} data-id="element-848" />;
    }
  };
  const getStepTitle = () => {
    switch (step) {
      case 1:
        return 'Create Your Account';
      case 2:
        return 'Choose Your Sport';
      case 3:
        return 'Choose Your Profile Type';
      case 4:
        return 'Complete Your Profile';
      case 5:
        return 'Welcome to SportProz';
      default:
        return 'Sign Up';
    }
  };
  // Don't show header on success screen
  const showHeader = step !== 5;
  return <div className="bg-white min-h-full flex flex-col" data-id="element-849">
      {showHeader && <div className="flex items-center px-4 py-3 border-b border-gray-200" data-id="element-850">
          {step > 1 && <button className="text-gray-800 mr-4" onClick={handleBack} data-id="element-851">
              <ArrowLeftIcon size={24} data-id="element-852" />
            </button>}
          <h1 className="text-lg font-semibold" data-id="element-853">{getStepTitle()}</h1>
          <div className="ml-auto flex space-x-2" data-id="element-854">
            <div className="text-sm text-gray-500" data-id="element-855">Step {step} of 4</div>
          </div>
        </div>}
      <div className="flex-1 overflow-y-auto" data-id="element-856">{renderStep()}</div>
    </div>;
};
export default SignupPage;